import { useRef } from "react";
import html2canvas from "html2canvas";
import { Modal } from "react-bootstrap";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import Lodderr from "../../components/Lodder/Lodder";
import "./BusinessCard.css";

const BusinessCardModel = ({ show, handleClose, data }) => {
  const { loading } = useSelector((s) => s.TimelineSlice);
  const cardRef = useRef();
  const member  = data?.[0];

  const handleDownload = async () => {
    const btn = cardRef.current?.querySelector(".bc-download-btn");
    if (btn) btn.style.display = "none";
    await new Promise(r => setTimeout(r, 200));

    const img = cardRef.current?.querySelector("img.bc-logo");
    if (img && img.src.includes("s3.amazonaws.com")) {
      const base = img.src.split("?")[0];
      img.src = `${base}?t=${Date.now()}`;
      await new Promise(r => { img.onload = r; img.onerror = r; });
    }

    const canvas = await html2canvas(cardRef.current, { useCORS:true, scale:2 });
    const a = document.createElement("a");
    a.download = `${member?.first_name || "business"}-card.png`;
    a.href = canvas.toDataURL("image/png");
    a.click();
    if (btn) btn.style.display = "";
  };

  const contacts = [
    { icon:"bx bx-phone",   val: member?.contact ? `+${member.country_code} ${member.contact}` : null },
    { icon:"bx bx-envelope",val: member?.email },
    { icon:"bx bx-globe",   val: member?.company_website || null },
    { icon:"bx bx-map-pin", val: member?.country },
  ].filter(c => c.val);

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleClose} size="md" centered dialogClassName="bc-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bx bx-id-card"></i> Business Card
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="bc-wrap">

            {/* ── Card ── */}
            <motion.div
              initial={{ opacity:0, y:16, scale:.96 }}
              animate={{ opacity:1, y:0,  scale:1 }}
              transition={{ duration:.4, ease:[.22,.68,0,1.2] }}>

              <div className="bc-card" ref={cardRef}>
                <div className="bc-top-bar" />

                <div className="bc-inner">
                  {/* Header: logo + company */}
                  <div className="bc-header-row">
                    <img
                      src={`${member?.company_logo || `${process.env.PUBLIC_URL}/company-logo-design.jpg`}?t=${Date.now()}`}
                      alt="logo"
                      className="bc-logo"
                      crossOrigin="anonymous"
                      onError={e => { e.target.onerror=null; e.target.src=`${process.env.PUBLIC_URL}/company-logo-design.jpg`; }}
                    />
                    <div>
                      <p className="bc-company-name">{member?.company_name || "Company Name"}</p>
                      <p className="bc-company-tagline">{member?.country || ""}</p>
                    </div>
                  </div>

                  {/* Name + title */}
                  <div className="bc-name-row">
                    <h2 className="bc-full-name">
                      {[member?.salutation, member?.first_name, member?.last_name].filter(Boolean).join(" ")}
                    </h2>
                    {member?.job_title && (
                      <p className="bc-job-title">{member.job_title}</p>
                    )}
                  </div>

                  {/* Contacts */}
                  {contacts.length > 0 && (
                    <div className="bc-contacts">
                      {contacts.map((c, i) => (
                        <div key={i} className="bc-contact-item">
                          <span className="bc-contact-icon"><i className={c.icon}></i></span>
                          <span className="bc-contact-text">{c.val}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="bc-bottom-bar" />
              </div>
            </motion.div>

            {/* Download button */}
            <motion.button
              className="bc-download-btn"
              onClick={handleDownload}
              whileHover={{ y:-2 }}
              whileTap={{ scale:.97 }}
              initial={{ opacity:0, y:8 }}
              animate={{ opacity:1, y:0 }}
              transition={{ delay:.2 }}>
              <i className="bx bx-download"></i> Download Card
            </motion.button>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BusinessCardModel;
